define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/heading/String",
	"csi/locale",
	"csi/widget/InlineSelect"
], function(array,declare,Memory,StringRen,locale,InlineSelect) {

	return declare(StringRen, {
		// Memory: store for format selection
		_store: null,

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: lookup description for stored format
			return locale.getFormat(value);
		},

		getAction: function(/*Context*/ctx, /*Heading*/h, /*Object?*/params) {
			// summary: use default controller if none given in heading
			var	a = this.inherited(arguments);
			if (a) {
				a.classController = a.classController || "csi.heading.SelectController";
			}

			return a;
		},

		getStore: function() {
			// summary: generate store for list of all formats minus restricted formats
			if (this._store) return this._store;
			
			this._store = new Memory({
				data: array.map(this._getFormats(), function(f) {
					return {id: f, name: this.formatValue(f)};
				}, this)
			});

			return this._store;
		},
		
		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: create widget for selecting format
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}
			
			if (params.store == null) {
				params.store = this.getStore();
			}
			
			return new InlineSelect(params);
		},

		_getFormats: function() {
			// summary: return array of common number formats
			return [
				"0",
				"0",
				"0.#",
				"0.##",
				"0.###",
				"0.####",
				"0.0",
				"0.00",
				"0.000",
				"0.0000",
				"#,##0",
				"#,##0.#",
				"#,##0.##",
				"#,##0.###",
				"#,##0.####",
				"#,##0.0",
				"#,##0.00",
				"#,##0.000",
				"#,##0.0000",
				"$#,##0",
				"$#,##0.0",
				"$#,##0.00",
				"$#,##0.000",
				"$#,##0.0000",
				"0%",
				"0.0%",
				"0.00%"
			];
		}
	});
});